import client from '../client'

/**
 * Get paginated list of users
 * @param {object} query a Profitboss query object
 * @returns {Promise} list of users
 */
export const getUsers = (query) => client.get('/users', query)

/**
 * A new Profitboss user
 * @param {object} user a Profitboss user object
 * @returns {Promise} resolves a user object
 */
export const createUser = (user) => client.post('/users', user)

/**
 * Deletes a User
 * @param {object} userId a Profitboss userId
 */
export const deleteUser = (userId) => client.delete(`/users/${userId}`)

/**
 * Updates Profitboss user
 * @param {string} userId Id of User To Update
 * @param {object} userUpdate Update to user object, should have corresponding keys in PbUser
 * @returns {Promise} Updated User
 */
export const updateUser = (userId, userUpdate) =>
  client.patch(`/users/${userId}`, userUpdate)
